export * from './classes';
export * from './color-picker.directive';
export * from './color-picker.module';
export * from './color-picker.service';



// WEBPACK FOOTER //
// ./~/angular2-color-picker/lib/index.ts